export default function AboutStory() {
  const milestones = [
    {
      year: "2025",
      title: "Started with one van, one promise",
      desc: "Cleario was founded by Wayne after years of seeing rogue traders and fly-tippers give the industry a bad name. One van, one region, one rule: every load disposed of properly and responsibly.",
      icon: "ri-truck-line",
    },
    {
      year: "2025",
      title: "Covering the West Midlands",
      desc: "Within the first year, Cleario expanded to serve Birmingham, Solihull, Droitwich Spa, Bromsgrove and Redditch — all using our own directly employed, DBS checked teams. No subcontractors.",
      icon: "ri-map-2-line",
    },
    {
      year: "2025",
      title: "Every employee DBS checked & vetted",
      desc: "From day one, every driver and operative has been directly employed, background checked, and fully vetted before stepping foot in a customer's home. That's non-negotiable at Cleario.",
      icon: "ri-shield-check-line",
    },
    {
      year: "2026",
      title: "Make-A-Wish Foundation milestone",
      desc: "We hit a milestone we're genuinely proud of — thousands of donations made to the Make-A-Wish Foundation, one for every single collection completed.",
      icon: "ri-heart-line",
    },
    {
      year: "2026",
      title: "Same-day is the new standard",
      desc: "Across all our operating areas you can now book and have us arrive the same day. Fixed pricing, digital waste notes, 95%+ recycled — every single job.",
      icon: "ri-calendar-check-line",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left copy */}
          <div>
            <div className="inline-flex items-center gap-2 bg-cl-lime/15 border-2 border-cl-lime/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-cl-lime inline-block"></span>
              <span className="text-cl-green font-black text-xs uppercase tracking-widest">How it started</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-black text-cl-dark leading-tight mb-6">
              We built the company<br />we <span className="text-cl-green">wished existed.</span>
            </h2>
            <p className="text-cl-dark/65 font-semibold text-base leading-relaxed mb-5">
              The rubbish removal industry was a mess — literally and figuratively. Rogue traders, vague pricing, and mountains of waste going straight to illegal tips. Wayne knew it could be done better.
            </p>

            {/* Hiring / people copy block */}
            <div className="bg-cl-dark rounded-2xl p-6 mb-6">
              <div className="flex items-start gap-3 mb-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-xl bg-cl-lime flex-shrink-0">
                  <i className="ri-user-star-line text-cl-dark text-base"></i>
                </span>
                <h3 className="text-white font-black text-base leading-snug pt-1">Our People Standard</h3>
              </div>
              <p className="text-white/75 text-sm font-semibold leading-relaxed mb-3">
                We only hire people we'd trust in our own homes. No subcontractors, no grey areas. Every driver, every van, every facility — Cleario-checked, Cleario-responsible.
              </p>
              <p className="text-white/75 text-sm font-semibold leading-relaxed">
                All employees are DBS checked and fully vetted before they ever step into a customer's property.
              </p>
              <div className="flex flex-wrap gap-2 mt-4">
                {["Directly employed", "DBS checked", "Fully vetted", "No subcontractors"].map((tag) => (
                  <span key={tag} className="bg-cl-lime text-cl-dark text-xs font-black px-3 py-1 rounded-full">{tag}</span>
                ))}
              </div>
            </div>

            <div className="bg-cl-tint rounded-3xl p-6 thick-border">
              <div className="flex items-start gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-2xl bg-cl-lime flex-shrink-0 cartoon-shadow-sm">
                  <i className="ri-double-quotes-l text-cl-dark text-xl"></i>
                </span>
                <div>
                  <p className="text-cl-dark font-black text-base leading-snug mb-2">
                    &ldquo;We didn&apos;t set out to build the biggest rubbish company. We set out to build the most responsible one.&rdquo;
                  </p>
                  <p className="text-cl-dark/60 text-sm font-semibold">— Wayne, Cleario Founder</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right timeline */}
          <div className="relative">
            <div className="absolute left-[19px] top-3 bottom-3 w-0.5 bg-cl-lime/30"></div>
            <div className="flex flex-col gap-8">
              {milestones.map((m) => (
                <div key={m.title} className="flex gap-5 items-start">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-cl-lime flex-shrink-0 thick-border cartoon-shadow-sm z-10">
                    <i className={`${m.icon} text-cl-dark text-sm`}></i>
                  </div>
                  <div className="pt-0.5">
                    <span className="inline-block bg-cl-dark text-cl-lime font-black text-xs px-3 py-0.5 rounded-full mb-1.5">{m.year}</span>
                    <h3 className="text-cl-dark font-black text-base mb-1">{m.title}</h3>
                    <p className="text-cl-dark/60 text-sm font-semibold leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
